import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  styles: {
    global: {
      colors: {
        blue: {
          300: '#00B9E7',
        },
      },
      html: {
        width: '100%',
        overflowX: 'hidden',
      },
      body: {
        width: '100%',
        overflowX: 'hidden',
      },
    },
  },
})
